import { apiClient } from '@isocel/front-common';

import { BaseModel, Package, PackagingConfig } from './types';
import { getAllTypes } from '../../utils/type.utils';

export const fetchPackageTypes = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageTypes`);
    return data;
};

export const fetchPackageCategories = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageCategories`);
    return data;
};

export const fetchModels = async (): Promise<BaseModel[]> => {
    const { data } = await apiClient().get(`/packageModels`);
    return data;
};

export const fetchPackages = async (): Promise<Package[]> => {
    const { data } = await apiClient().get(`/packages`);
    return data;
};

export const fetchPackagingConfig = async (): Promise<PackagingConfig> => {
    const { data } = await apiClient().get(`/packagingConfig`);
    const allTypes = await getAllTypes();

    // Merge packageTypes with allTypes based on matching IDs
    const mergedPackageTypes = data.packageTypes.map((packageType: BaseModel) => {
        const matchingType = allTypes.find((type: any) => type._id === packageType.id);
        return {
            ...packageType,
            ...matchingType, // Overwrite or add properties from matchingType
        };
    });

    // Merge type object inside each package with allTypes based on matching IDs
    const mergedPackages = data.packages.map((pkg: Package) => {
        const matchingType = allTypes.find((type: any) => type._id === pkg.type.id);
        return {
            ...pkg,
            type: {
                ...pkg.type,
                ...matchingType, // Overwrite or add properties from matchingType
            },
        };
    });
    return {
        ...data,
        packageTypes: mergedPackageTypes,
        packages: mergedPackages,
    };
};
